import type { LocaleCode } from './locales'

export const PILOT_TRANSLATED_PATHS: Partial<Record<LocaleCode, readonly string[]>> = {
  // Spanish-only pilot for now.
  // Keep this list strict: only add paths with real translated content.
  es: [
    '/',
    '/calculators',
    '/electrical',
    '/calculators/ohms-law',
    '/calculators/voltage-divider',
    '/calculators/electrical-power',
    '/calculators/resistor',
    '/calculators/resistor-color-code',
    '/calculators/rc-time-constant',
    '/calculators/voltage-drop',
    '/calculators/impedance',
    '/calculators/led-resistor',
    '/calculators/resistor-network',
    '/calculators/capacitor-energy',
    '/calculators/transformer',
    '/calculators/power-factor',
    '/calculators/three-phase-power',
    '/converters',
    '/tools',
    '/generators',
    '/contact',
    '/privacy',
    '/terms',
  ],
}
